/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Ical_SubscribeInputs */

const cs_settings_profile_ical_subscribe = /** @type {(inputs: Settings_Profile_Ical_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebírat`)
};

const en_settings_profile_ical_subscribe = /** @type {(inputs: Settings_Profile_Ical_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Settings_Profile_Ical_SubscribeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_ical_subscribe = /** @type {((inputs?: Settings_Profile_Ical_SubscribeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Ical_SubscribeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_ical_subscribe(inputs)
	return cs_settings_profile_ical_subscribe(inputs)
});